import { Link } from "react-router-dom";

const SoDashboard = () => {
  const routes = [
    {
      name: "Customers",
      path: "/customers",
    },
    {
      name: "Interview Candidates",
      path: "/interview",
    },
    {
      name: "Supplements",
      path: "/supplement",
    },
    {
      name: "Upload",
      path: "/upload",
    },
    {
      name: "Front Desk",
      path: "/front-desk",
    },
    {
      name: "Send Mail",
      path: "/email",
    },
  ];

  return (
    <div className="w-[80%] mx-auto h-[70vh] flex flex-col justify-between item-center mt-10">
      <div className="grid grid-cols-3 grid-rows-2 gap-8">
        {routes.map((route) => (
          <div className="flex justify-center items-center">
            <Link
              key={route.path}
              to={route.path}
              className="flex justify-center items-center w-fit"
            >
              <div className="w-[250px] h-[150px] bg-slate-200 border border-slate-400 flex justify-center items-center p-4 rounded-xl hover:shadow-gray-400 shadow-lg">
                <h1 className="text-xl font-bold">{route.name}</h1>
              </div>
            </Link>
          </div>
        ))}
      </div>
      {/* <div className="flex justify-between">
        <Link to="/email" className="w-fit">
          <div className="p-4 bg-slate-200 rounded-full border border-gray-400 w-[80px] h-[80px] flex justify-center items-center -rotate-45 shadow-lg hover:shadow-gray-400">
            <svg
              width="60"
              height="60"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
          </div>
        </Link>
      </div> */}
    </div>
  );
};

export default SoDashboard;
